import { useEffect, useState } from "react";
import DefaultFooter from "../components/default-footer";

import DefaultHeader from "../components/default-header";
import SectionSubscribe from "../components/sectionSubscribe";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Slider from "rc-slider";
import toursData from "./../data/tours";
import AOS from "aos";
import "aos/dist/aos.css";
import isTextMatched from "../utils/isTextMatched";
import "rc-slider/assets/index.css";
import { hotelsData } from "./../data/hotels";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { testimonial2 } from "../data/testimonialData";


const PageReviews = () => {

  
    const brandImages = ["1", "2", "3", "4"];


  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out", 
      once: true, 
    });
  }, []);

 



    return (
      <>
   
         {/* End Page Title */}

      <div className="header-margin"></div>
      {/* header top margin */}
        <DefaultHeader />
      {/* End Header 1 */}
      
     
      <section className="section-bg layout-pt-lg layout-pb-lg">
        <div className="section-bg__item -mx-20 bg-light-2" />
        <div className="container">
          <div className="row justify-center text-center">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">
                  Overheard from Travelers
                </h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">
                  These popular destinations have a lot to offer
                </p>
              </div>
            </div>
          </div>
          {/* End .row */}

          <div className="relative mt-80 md:mt-40 position-relative" data-aos="fade-up" style={{ overflow: "hidden" }}>
  <Swiper
    modules={[Navigation, Autoplay]} 
    spaceBetween={30}
    className="overflow-visible"
    navigation={{
      nextEl: ".js-hm4tm-next-active",
      prevEl: ".js-hm4tm-prev-active",
    }}
    autoplay={{      
      delay: 3000,         
      disableOnInteraction: false, 
    }}
    breakpoints={{
      500: { slidesPerView: 2, spaceBetween: 20 },
      768: { slidesPerView: 2, spaceBetween: 22 },
      1024: { slidesPerView: 3 },
      1200: { slidesPerView: 3 },
    }}
  >
    {testimonial2.map((item) => (
      <SwiperSlide key={item.id}>
        <div
          className="testimonials -type-1 bg-white rounded-4 pt-40 pb-30 px-40"
          data-aos="fade"
          data-aos-delay={item.dealyAnimation}
        >
          <h4 className="text-16 fw-500 text-blue-1 mb-20">{item.meta}</h4>
          <p className="testimonials__text lh-18 fw-500 text-dark-1">{item.text}</p>
          <div className="pt-20 mt-28 border-top-light">
            <div className="row x-gap-20 y-gap-20 items-center">
              <div className="col-auto">
                <img width={60} height={60} src={item.avatar} alt="image" className="size-60" />
              </div>
              <div className="col-auto">
                <div className="text-15 fw-500 lh-14">{item.name}</div>
                <div className="text-14 lh-14 text-light-1 mt-5">{item.designation}</div>
              </div>
            </div>
          </div>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>

  <button className="section-slider-nav -prev flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-hm4tm-prev-active">
    <i className="icon icon-chevron-left text-12" />
  </button>

  <button className="section-slider-nav -next flex-center button -blue-1 bg-white shadow-1 size-40 rounded-full sm:d-none js-hm4tm-next-active">
    <i className="icon icon-chevron-right text-12" />
  </button>
</div>
          {/* End .overflow-hidden */}

          <div className="row y-gap-30 items-center pt-40 sm:pt-20">
            <div className="col-xl-4">
              
            <div className="row y-gap-30 text-dark-1">
      <div className="col-sm-5 col-6">
        <div className="text-30 lh-15 fw-600">13m+</div>
        <div className="lh-15">Happy People</div>
      </div>
      {/* End .col */}

      <div className="col-sm-5 col-6">
        <div className="text-30 lh-15 fw-600">4.88</div>
        <div className="lh-15">Overall rating</div>
        <div className="d-flex x-gap-5 items-center pt-10">
          <div className="icon-star text-dark-1 text-10" />
          <div className="icon-star text-dark-1 text-10" />
          <div className="icon-star text-dark-1 text-10" />
          <div className="icon-star text-dark-1 text-10" />
          <div className="icon-star text-dark-1 text-10" />
        </div>
      </div>
    </div>
            </div>
            {/* End .col */}

            <div className="col-xl-8">
              <div className="row y-gap-30 justify-between items-center">
              {brandImages.map((item, i) => (
        <div className="col-md-auto col-sm-6" key={i}>
          <div className="d-flex justify-center">
            <img src={`/img/clients/${item}.svg`} alt="image" />
          </div>
        </div>
      ))}
              </div>
            </div>
            {/* End .col */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </section>


      <section style={{ paddingBottom:"60px", paddingTop:"60px" }} data-aos="fade-up">
        <div className="container">
          <div className="row y-gap-20 justify-center text-center">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title">Leave a Reply</h2>
                <p className=" sectionTitle__text mt-5 sm:mt-0">
                  Your email address will not be published.
                </p>
              </div>
            </div>
            {/* End .col */}
          </div>
          {/* End .row */}

          <div className="row justify-center pt-40 sm:pt-20">
  <div className="col-lg-6 col-md-8">
    <form className="row y-gap-30">
      <div className="col-12">
        <div className="form-input">
          <input type="text" placeholder="Text" required />
        </div>
      </div>

      <div className="col-12">
        <div className="form-input">
          <input type="text" placeholder="Email" required />
        </div>
      </div>

      <div className="col-12">
        <div className="form-input">
          <textarea required rows={6} defaultValue={""} placeholder="Write Your Comment" />
        </div>
      </div>

      <div className="col-12 text-center">
        <button
          type="submit"
          className="button -md -dark-1 bg-blue-1 text-white"
        >
          Post Comment <div className="icon-arrow-top-right ml-15" />
        </button>
      </div>
    </form>
  </div>
</div>

          {/* End .row */}
        </div>
        {/* End .container */}
      </section>



      <SectionSubscribe />
      {/* End Call To Actions Section */}

      <DefaultFooter />

      </>
    );
  };
  
  export default PageReviews;
  